import { render } from "./ManagementPage.vue?vue&type=template&id=ebae8b94&scoped=true&lang=pug"
import script from "./ManagementPage.vue?vue&type=script&lang=js"
export * from "./ManagementPage.vue?vue&type=script&lang=js"

import "./ManagementPage.vue?vue&type=style&index=0&id=ebae8b94&lang=scss&scoped=true"
import "./ManagementPage.vue?vue&type=style&index=1&id=ebae8b94&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebae8b94"]])

export default __exports__